import React from 'react';

export const TYPES = {
  DEFAULT: 'default',
  SUBMIT: 'submit'
}

export const Button = ({
  text,
  onClick,
  type,
  disabled,
  buttonType,
  selected
}) => {
  const styles = {
    base: {
      backgroundColor: '#016AF3',
      padding: '5px 15px',
      borderRadius: '5px',
      border: '0px',
      height: '50px',
      fontSize: '14px',
      color: 'white',
      fontFamily: '',
    },
    admin: {
      backgroundColor: '#01D4FE',
    },
    default: {
      backgroundColor: '#016AF3'
    },
    recordingsSearch: {
      background: 'linear-gradient(to bottom right, #00D4FE, #028BFE)',
      height: '40px',
      marginLeft: '45px'

    },
    recordingsAction: {
      backgroundColor: '#016AF3',
      height: '40px',
      margin: '5px',
      padding: '10px',
      width: '135px',
      cursor: 'pointer'
    },
    recordingsActionDisabled: {
      backgroundColor: '#CFCFCF',
      height: '40px',
      margin: '5px',
      padding: '10px',
      width: '135px',
      cursor: 'pointer'
    },
    note: {
      background: 'linear-gradient(to bottom right, #00D4FE, #028BFE)',
      height: '35px',
      width: '100px',
      margin: '5px',
      cursor: 'pointer'
    },

    viewNote: {
      background: 'linear-gradient(to bottom right, #00D4FE, #028BFE)',
      height: '35px',
      width: '150px',
      margin: '5px',
    },

    reviewOne: {
      borderRadius: '50px',
      background: '#028BFE',
      width: '180px',
      cursor: 'pointer'
    },
    reviewTwo: {
      borderRadius: '50px',
      background: '#00D4FE',
      width: '175px',
      cursor: 'pointer'
    },
    videoControl: {
      border: 'solid #FFFFFF 2px',
      background: 'rgba(0, 0, 0, 0)',
      color: '#FFFFFF',
      width: '100px',
      height: '45px'
    },
    controlSelected: {
      border: 'solid #FFFFFF 2px',
      background: '#FFFFFF',
      width: '100px',
      height: '45px',
      color: '#016AF3'
    },
    videoSpeed: {
      border: 'solid #FFFFFF 2px',
      background: 'rgba(0, 0, 0, 0)',
      color: '#FFFFFF',
      width: '75px',
      height: '45px',
      marginRight: '10px'
    },
    speedSelected: {
      border: 'solid #FFFFFF 2px',
      background: '#FFFFFF',
      width: '75px',
      height: '45px',
      color: '#016AF3',
      marginRight: '10px'
    },
    addNote: {
      background: '#00D4FE',
      color: '#FFFFFF',
      width: '100px',
      height: '45px'
    },
    saveNote: {
      background: 'linear-gradient(to bottom right, #00D4FE, #028BFE)',
      height: '40px',
      margin: '5px',
      padding: '10px',
      width: '100px'
    },
    landing: {
      border: '2px solid #FFFFFF',
      borderRadius: '30px',
      width: '150px',
      background: 'rgba(0, 0, 0, 0)',
      fontSize: '17px',
      cursor: 'pointer'
    },
    landingMedia: {
      border: '2px solid #FFFFFF',
      borderRadius: '30px',
      width: '150px',
      background: 'rgba(0, 0, 0, 0)',
      fontSize: '17px',
      cursor: 'pointer',
    },
    getDemo: {
      border: '2px solid #FFFFFF',
      borderRadius: '30px',
      width: '200px',
      background: 'rgba(0, 0, 0, 0)',
      fontSize: '17px',
      cursor: 'pointer'
    },
    logIn: {
      borderRadius: '30px',
      fontSize: '17px',
      background: 'linear-gradient(to bottom right, #00D4FE, #028BFE)',
      width: '170px'
    },
    restore: {
      backgroundColor: '#FF5757',
      marginLeft: '65px'
    }
  }

  if (type === "videoSpeed" && selected) {
    type = "speedSelected"
  }

  if (type === "videoControl" && selected) {
    type = "controlSelected"
  }

  if(buttonType === TYPES.SUBMIT) {
    return (
      <input
        type="submit"
        disabled={disabled}
        onClick={onClick}
        style={{...styles.base, ...styles[type]}}
        value={text}
      />
    )
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={{...styles.base, ...styles[type]}}
    >
      {text}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/button.js